<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Placa" prop="placa" :rules="[$requiredBlur]" key="placa">
              <el-input v-model="dados.placa" maxlength="20" v-on:blur="formatUpper('placa')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Tipo" prop="tipo" :rules="[$requiredChange]" key="tipo">
              <el-select v-model="dados.tipo">
                <el-option label="ÔNIBUS" value="onibus"></el-option>
                <el-option label="VAN" value="van"></el-option>
                <el-option label="MICRO-ÔNIBUS" value="micro-onibus"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Status" prop="status" :rules="[$requiredChange]" key="status">
              <el-select v-model="dados.status">
                <el-option label="ATIVO" value="ativo"></el-option>
                <el-option label="MANUTENÇÃO" value="manutencao"></el-option>
                <el-option label="INATIVO" value="inativo"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <!--
              BLOCO Z, itens 10 e 21 — o CAMPO DE TEXTO permanece (veículo já cadastrado
              continua legível). A seleção do cadastro fica ao lado, opcional.
            -->
            <el-form-item label="Modelo (texto)" prop="modelo" key="modelo">
              <el-input v-model="dados.modelo" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Marca (texto)" prop="marca" key="marca">
              <el-input v-model="dados.marca" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="4" :md="4">
            <el-form-item label="Ano" prop="ano" key="ano">
              <el-input v-model="dados.ano" maxlength="4"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="4" :md="4">
            <el-form-item label="Capacidade" prop="capacidade" key="capacidade">
              <el-input v-model="dados.capacidade" maxlength="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Quilometragem atual" prop="quilometragem_atual" key="quilometragem_atual">
              <el-input v-model="dados.quilometragem_atual" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
          <!-- ==================== Catalogação da frota — Bloco Z ==================== -->
          <el-divider content-position="left">Catálogo da frota</el-divider>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="8">
              <el-form-item label="Marca (cadastro)" key="marca_id">
                <el-select v-model="dados.marca_id" placeholder="Selecione" clearable filterable
                           style="width:100%" @change="dados.modelo_id = ''">
                  <el-option v-for="m in marcas" :key="m.id" :label="m.nome" :value="m.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Modelo (cadastro)" key="modelo_id">
                <el-select v-model="dados.modelo_id" placeholder="Selecione" clearable filterable
                           style="width:100%" :disabled="!dados.marca_id">
                  <el-option v-for="m in modelosDaMarca" :key="m.id" :label="m.nome" :value="m.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Tipo de transporte (cadastro)" key="tipo_transporte_id">
                <el-select v-model="dados.tipo_transporte_id" placeholder="Selecione" clearable
                           filterable style="width:100%">
                  <el-option v-for="t in tiposTransporte" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ==================== Apólices — item 18 ==================== -->
          <div v-if="dados.id">
            <el-divider content-position="left">Apólices de seguro</el-divider>

            <el-alert v-if="apoliceVencendo" type="warning" show-icon :closable="false" class="u-mb-10"
                      :title="apoliceVencendo"></el-alert>

            <el-button v-if="podeOperar" type="primary" plain icon="el-icon-plus" size="mini"
                       class="u-mb-10" @click="abrirApolice(null)">NOVA APÓLICE</el-button>

            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Seguradora</th><th style="width:150px;">Nº apólice</th>
                  <th style="width:200px;">Vigência</th>
                  <th style="width:110px;" class="u-text-center">Situação</th>
                  <th style="width:110px;" class="u-text-center" v-if="podeOperar">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="a in apolices" :key="a.id">
                  <td>{{ a.seguradora }}</td>
                  <td>{{ a.numero_apolice }}</td>
                  <td>{{ formatarData(a.vigencia_inicio) }} a {{ formatarData(a.vigencia_fim) }}</td>
                  <td class="u-text-center">
                    <el-tag v-if="a.vigente" type="success" size="mini">vigente</el-tag>
                    <el-tag v-else-if="a.dias_para_vencer !== null && a.dias_para_vencer < 0" type="danger" size="mini">vencida</el-tag>
                    <el-tag v-else type="info" size="mini">futura</el-tag>
                  </td>
                  <td class="u-text-center" v-if="podeOperar">
                    <el-button @click="abrirApolice(a)" title="Editar" type="info" icon="el-icon-edit"
                               size="mini" plain class="u-mr-5"></el-button>
                    <el-button @click="excluirApolice(a)" title="Excluir" type="danger"
                               icon="el-icon-delete" size="mini" plain></el-button>
                  </td>
                </tr>
                <tr v-if="apolices.length === 0">
                  <td :colspan="podeOperar ? 5 : 4" class="u-text-center">Nenhuma apólice registrada.</td>
                </tr>
              </tbody>
            </table>
          </div>


        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-veiculo" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <el-dialog :title="apoliceEditando ? 'Editar apólice' : 'Nova apólice'"
               :visible.sync="dialogApolice" width="640px" append-to-body>
      <el-form :model="formApolice" label-position="top">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12">
            <el-form-item label="Seguradora *"><el-input v-model="formApolice.seguradora" maxlength="191"></el-input></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Número da apólice *"><el-input v-model="formApolice.numero_apolice" maxlength="60"></el-input></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Início da vigência *">
              <el-date-picker v-model="formApolice.vigencia_inicio" type="date" value-format="yyyy-MM-dd"
                              format="dd/MM/yyyy" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Fim da vigência *">
              <el-date-picker v-model="formApolice.vigencia_fim" type="date" value-format="yyyy-MM-dd"
                              format="dd/MM/yyyy" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Prêmio (R$)"><el-input v-model="formApolice.valor_premio" type="number"></el-input></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Cobertura (R$)"><el-input v-model="formApolice.valor_cobertura" type="number"></el-input></el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Descrição da cobertura">
              <el-input type="textarea" :rows="2" v-model="formApolice.cobertura_descricao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogApolice = false">CANCELAR</el-button>
        <el-button class="u-ml-10" type="primary" @click="salvarApolice" :loading="salvandoApolice">SALVAR</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    edit: false,
    filtroInstituicao: { id: '', nome: '' },
    dados: {
      id: '',
      instituicao_id: '',
      placa: '',
      modelo: '',
      marca: '',
      ano: '',
      capacidade: '',
      tipo: 'onibus',
      status: 'ativo',
      quilometragem_atual: 0,

      // BLOCO Z — FKs do catálogo da frota, todas opcionais.
      marca_id: '',
      modelo_id: '',
      tipo_transporte_id: ''
    },

    // Catálogos e apólices (itens 10, 21 e 18).
    marcas: [],
    modelos: [],
    tiposTransporte: [],
    apolices: [],
    dialogApolice: false,
    salvandoApolice: false,
    apoliceEditando: null,
    formApolice: {}
  }),
  computed: {
    podeOperar () { return [0, 1, 4, 5, 6, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1 },

    modelosDaMarca () {
      if (!this.dados.marca_id) return []
      return this.modelos.filter(m => String(m.marca_id) === String(this.dados.marca_id))
    },

    /** Item 18 — o alerta que o painel também mostra. */
    apoliceVencendo () {
      const vig = this.apolices.filter(a => a.vigente)
      if (!vig.length) {
        return this.apolices.length
          ? 'Nenhuma apólice vigente para este veículo hoje.'
          : null
      }
      const proxima = vig.sort((a, b) => a.dias_para_vencer - b.dias_para_vencer)[0]
      if (proxima.dias_para_vencer !== null && proxima.dias_para_vencer <= 30) {
        return `A apólice ${proxima.numero_apolice} vence em ${proxima.dias_para_vencer} dia(s).`
      }
      return null
    },

    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.carregarCatalogos()
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    formatarData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' },

    /** Marcas, modelos e tipos — falha em um não derruba o formulário. */
    carregarCatalogos () {
      const base = this.$store.state.config.baseUrlApi
      const h = this.$store.getters.getHeaderAuth

      this.$axios.post(`${base}/api/transporte-escolar/marca/getAllPaginate`, { per_page: 200, situacao: 1 }, h)
        .then(r => { this.marcas = (r.data && !r.data.erro) ? (r.data.data || []) : [] }).catch(() => {})

      this.$axios.post(`${base}/api/transporte-escolar/modelo/getAllPaginate`, { per_page: 200, situacao: 1 }, h)
        .then(r => { this.modelos = (r.data && !r.data.erro) ? (r.data.data || []) : [] }).catch(() => {})

      this.$axios.post(`${base}/api/tipo-transporte/getAllPaginate`, { per_page: 200 }, h)
        .then(r => { this.tiposTransporte = (r.data && !r.data.erro) ? (r.data.data || r.data || []) : [] })
        .catch(() => {})
    },

    // ---------------------------------------------------------------- item 18

    carregarApolices () {
      if (!this.dados.id) return

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/apolice/porVeiculo/${this.dados.id}`,
                      this.$store.getters.getHeaderAuth)
        .then(r => { this.apolices = (r.data && !r.data.erro) ? r.data : [] })
        .catch(() => { this.apolices = [] })
    },

    abrirApolice (a) {
      this.apoliceEditando = a
      this.formApolice = a
        ? JSON.parse(JSON.stringify(a))
        : { veiculo_id: this.dados.id, seguradora: '', numero_apolice: '',
            vigencia_inicio: '', vigencia_fim: '', valor_premio: '', valor_cobertura: '',
            cobertura_descricao: '' }
      this.formApolice.veiculo_id = this.dados.id
      this.dialogApolice = true
    },

    salvarApolice () {
      this.salvandoApolice = true
      const base = `${this.$store.state.config.baseUrlApi}/api/transporte-escolar/apolice`
      const url = this.apoliceEditando ? `${base}/update/${this.apoliceEditando.id}` : `${base}/store`

      this.$axios.post(url, this.formApolice, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.salvandoApolice = false
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.dialogApolice = false
          window.eventBus.$emit('alert', { msg: 'Apólice salva.', type: 'success' })
          this.carregarApolices()
        }).catch(e => { this.salvandoApolice = false; this.$store.commit('throwException', e) })
    },

    excluirApolice (a) {
      this.$msgbox.confirm('Excluir esta apólice?', 'Atenção',
        { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/apolice/delete/${a.id}`,
                             this.$store.getters.getHeaderAuth)
            .then(r => {
              if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
              window.eventBus.$emit('alert', { msg: 'Apólice excluída.', type: 'success' })
              this.carregarApolices()
            }).catch(e => this.$store.commit('throwException', e))
        }).catch(() => {})
    },

    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/veiculo/getById/` + id, this.$store.getters.getHeaderAuth)

      if (res.data && res.data.erro) {
        return window.eventBus.$emit('alert', { msg: res.data.erro, type: 'warning' })
      }

      this.dados = JSON.parse(JSON.stringify(res.data))
      this.carregarApolices()
    },
    onSubmit () {
      document.getElementById("btn-veiculo").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/veiculo/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
          } else {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/veiculo/store`, this.dados, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitVeiculo')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    },
    formatUpper (field) {
      if (!this.dados[field]) return
      this.dados[field] = this.$removerAcentos(String(this.dados[field]).toUpperCase())
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        }
      }
    }
  }
}
</script>

